import { render, staticRenderFns } from "./numberTextStyleTop.vue?vue&type=template&id=1ccda4d6&"
import script from "./numberTextStyleTop.vue?vue&type=script&lang=ts&"
export * from "./numberTextStyleTop.vue?vue&type=script&lang=ts&"
import style0 from "./numberTextStyleTop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports